import { useEffect, useRef } from "react";
import { Image } from "@/components/ui/image";

/**
 * The rest of the album, immediately under the cover, so the whole gallery sits
 * in one place and the strip keeps in step with whatever the cover is showing.
 */
export default function HeroThumbs({ photos = [], active = 0, onPick }) {
  const strip = useRef(null);

  // Keep the photo currently on the cover centred in the strip as it advances.
  useEffect(() => {
    const node = strip.current;
    const thumb = node?.children?.[active];
    if (!node || !thumb) return;
    const target = thumb.offsetLeft - (node.clientWidth - thumb.clientWidth) / 2;
    node.scrollTo({ left: Math.max(0, target), behavior: "smooth" });
  }, [active]);

  return (
    <div
      ref={strip}
      className="no-scrollbar mt-2 flex gap-2 overflow-x-auto pb-0.5"
      aria-label="Photos in this gallery"
    >
      {photos.map((src, index) => (
        <button
          key={`${src}-${index}`}
          type="button"
          onClick={() => onPick?.(index)}
          aria-label={`Show photo ${index + 1}`}
          aria-pressed={index === active}
          className={`relative h-[56px] w-[76px] shrink-0 overflow-hidden rounded-[9px] bg-[#eceae5] transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#171717] dark:bg-[#242520] dark:focus-visible:ring-[#f2efe9] ${
            index === active
              ? "opacity-100 ring-2 ring-[#171717] dark:ring-[#f2efe9]"
              : "opacity-70 hover:opacity-100"
          }`}
        >
          <Image src={src} alt="" fittingType="fill" className="h-full w-full object-cover" />
        </button>
      ))}
    </div>
  );
}